export default __webpack_public_path__ + "static/media/2_2.c7af54dd.png";